export default "__VITE_ASSET__0xfIrG$C__"